export const BCC_EMAIL = "universe@50y.com";
export const CHROME_EXTENSION_LINK =
  "https://chrome.google.com/webstore/detail/50y-connector/nehnklfmpebjaafcagdafiheajnndjad";
export const PACIFIC_TIMEZONE = "America/Los_Angeles";
export const EVENT_CARD_DATE_FORMAT = "ddd MMM Do YYYY";
export const EVENT_CARD_TIME_FORMAT = "hA PT";
